import { Button, Center, Stack, Text, Title } from '@mantine/core';
import { IconCheck, IconX } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const REDIRECT_URL_KEY = 'gbase_auth_redirect_url';

export default function GbaseAuthSuccess() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [countdown, setCountdown] = useState(3);

  const status = searchParams.get('status');
  const userId = searchParams.get('user_id');
  const botId = searchParams.get('bot_id');
  const message = searchParams.get('message');

  const isSuccess = status === 'success';

  // 调试信息
  useEffect(() => {
    console.log('GbaseAuthSuccess - URL参数:', {
      status,
      userId,
      botId,
      message,
      fullUrl: window.location.href,
    });
  }, [status, userId, botId, message]);

  // 获取保存的跳转地址，并添加 isOpen=true 参数
  const getRedirectUrl = () => {
    let redirectUrl = '';

    const savedUrl = localStorage.getItem(REDIRECT_URL_KEY);
    if (savedUrl) {
      localStorage.removeItem(REDIRECT_URL_KEY);
      redirectUrl = savedUrl;
    } else if (botId) {
      // 如果有 botId，跳转到对应机器人的数据源页面
      redirectUrl = `/bot/${botId}/data-source`;
    } else {
      // 默认跳转到机器人列表
      redirectUrl = '/bots';
    }

    // 添加 isOpen=true 参数（如果授权成功）
    if (isSuccess) {
      const separator = redirectUrl.includes('?') ? '&' : '?';
      redirectUrl = `${redirectUrl}${separator}isOpen=true`;
    }

    return redirectUrl;
  };

  // 自动跳转倒计时
  useEffect(() => {
    if (isSuccess && countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else if (isSuccess && countdown === 0) {
      handleRedirect();
    }
  }, [countdown, isSuccess]);

  const handleRedirect = () => {
    const redirectUrl = getRedirectUrl();
    navigate(redirectUrl);
  };

  return (
    <Center style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
      <Stack align="center" gap="lg" style={{ maxWidth: 500, padding: '2rem' }}>
        {isSuccess ? (
          <>
            <div
              style={{
                width: 80,
                height: 80,
                borderRadius: '50%',
                backgroundColor: '#d4f4dd',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <IconCheck size={48} color="#28a745" />
            </div>
            <Title order={2}>{t('create_v2.integrations.data_sources.gbase_project.auth_success_title')}</Title>
            <Text size="md" c="dimmed" ta="center">
              {t('create_v2.integrations.data_sources.gbase_project.auth_success_desc')}
            </Text>
            {userId && (
              <Text size="sm" c="dimmed">
                User ID: {userId}
              </Text>
            )}
            <Text size="sm" c="dimmed">
              {t('create_v2.integrations.data_sources.gbase_project.auth_success_redirect', { seconds: countdown })}
            </Text>
            <Button onClick={handleRedirect} size="md">
              {t('create_v2.integrations.data_sources.gbase_project.auth_success_btn')}
            </Button>
          </>
        ) : (
          <>
            <div
              style={{
                width: 80,
                height: 80,
                borderRadius: '50%',
                backgroundColor: '#ffe4e4',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <IconX size={48} color="#dc3545" />
            </div>
            <Title order={2}>{t('create_v2.integrations.data_sources.gbase_project.auth_fail_title')}</Title>
            <Text size="md" c="dimmed" ta="center">
              {message
                ? decodeURIComponent(message)
                : t('create_v2.integrations.data_sources.gbase_project.auth_fail_desc')}
            </Text>
            <Button onClick={handleRedirect} size="md" color="gray">
              {t('create_v2.integrations.data_sources.gbase_project.auth_fail_btn')}
            </Button>
          </>
        )}
      </Stack>
    </Center>
  );
}
